import { ReactComponent as CloudSavingSpinnerImg } from "@/data-preparation-tool/icons/cloud-saving-spinner.svg";
import { WorkflowDialog } from "@faro-lotv/data-management";
import { JSX } from "react/jsx-runtime";

/**
 * @param open Whether the dialog is open.
 * @returns A dialog to show the progress of saving the user edits.
 */
export function SavingUserEditsDialog({
  open,
}: {
  open: boolean;
}): JSX.Element {
  return (
    <WorkflowDialog
      open={open}
      variant="notice"
      image={CloudSavingSpinnerImg}
      title="Saving your changes..."
      description="Please don't close the browser while we save."
    />
  );
}
